import { useFamily } from '../context/FamilyContext';

export const usePermissions = () => {
  const { isHouseholdMember } = useFamily();
  const isParent = !isHouseholdMember;

  return {
    isParent,
    isHouseholdMember,
    canDelete: isParent,
    canSettle: isParent,
    canManageCustody: isParent,
    canManageFamilySettings: isParent,
    canRemoveMembers: isParent,
  };
};
